<template>
  <div
    class="base-tabs"
    :class="{'base-tabs--underlined': underlined}"
  >
    <div
      v-for="(item, index) in items"
      :key="index"
      class="base-tabs__item"
      :class="{'active': index === value, 'base-tabs__item--underlined': underlined, 'base-tabs_item--bold': bold}"
      :style="{'min-width': minWidth}"
      @click="onSelect(index)"
    >
      {{ item.text ? item.text : item }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseTabs',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    underlined: {
      type: Boolean,
      default: false,
    },
    minWidth: {
      type: String,
      default: '',
    },
    bold: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onSelect(index) {
      if (!this.items[index].disabled) {
        this.$emit('input', index);
        this.$emit('tabChanged', index);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.base-tabs {
  display: flex;
  justify-content: flex-end;
  &--underlined {
    width: 100%;
  }
  &__item {
    background-color: rgba(white, 0.5);
    font-size: 0.875rem;
    font-family: $font-family-sans-serif-light;
    margin-left: 0.5rem;
    min-width: 170px;
    min-height: 2rem;
    border-radius: .5vw .5vw 0 0;
    padding: 0.3rem 0rem;
    cursor: pointer;
    transition: all 0.2s;
    flex: none;
    text-align: center;
    font-weight: 300;
    color: #646464;

    &--underlined {
      padding: 0.3rem 0.5rem;
      min-width: inherit !important;
      &.active {
        border-bottom: 1.3px black solid;
        padding-bottom: 4px;
      }
    }

    &--bold {
      font-weight: bold;
    }

    &.active {
      background-color: white;
      font-weight: 400;
    }
  }
}
</style>
